export default "__VITE_ASSET__Ci1Rln8n__"